import { render, staticRenderFns } from "./workstationForm.vue?vue&type=template&id=39eab60a&scoped=true&"
import script from "./workstationForm.vue?vue&type=script&lang=js&"
export * from "./workstationForm.vue?vue&type=script&lang=js&"
import style0 from "./workstationForm.vue?vue&type=style&index=0&id=39eab60a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eab60a",
  null
  
)

export default component.exports